import React, { useState } from 'react';

export default function KanbanHeaderCell({ board, cardCount, onAddCard }) {
  const [showAddForm, setShowAddForm] = useState(false);
  const [newTitle, setNewTitle] = useState('');
  const [adding, setAdding] = useState(false);

  const handleAdd = async () => {
    if (!newTitle.trim() || adding) return;
    setAdding(true);
    try {
      await onAddCard(board.boardID, newTitle.trim());
      setNewTitle('');
      setShowAddForm(false);
    } finally {
      setAdding(false);
    }
  };

  return (
    <div className="kanban-column kanban-head-cell">
      <div className="kanban-column-wrapper kanban-head-wrapper">
        <div className="kanban-column-header">
          <div className="kanban-column-title-wrap">
            <span className="kanban-column-title" title={board.boardName}>
              {board.boardName}
            </span>
            <span className="kanban-column-count">{cardCount}</span>
          </div>
        </div>

        {showAddForm ? (
          <div className="tasks-add-card-form">
            <input
              type="text"
              placeholder="Enter card title"
              value={newTitle}
              onChange={(e) => setNewTitle(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleAdd();
                if (e.key === 'Escape') setShowAddForm(false);
              }}
              autoFocus
            />
            <div className="tasks-add-card-actions">
              <button type="button" className="tasks-btn-primary" onClick={handleAdd} disabled={adding}>
                Add
              </button>
              <button type="button" className="tasks-btn-secondary" onClick={() => setShowAddForm(false)}>
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <button
            type="button"
            className="kanban-add-card-btn kanban-add-card-btn-top"
            onClick={() => setShowAddForm(true)}
          >
            + Add a card
          </button>
        )}
      </div>
    </div>
  );
}
